import { render, staticRenderFns } from "./addActivty.vue?vue&type=template&id=5d5c3fc8&scoped=true&"
import script from "./addActivty.vue?vue&type=script&lang=js&"
export * from "./addActivty.vue?vue&type=script&lang=js&"
import style0 from "./addActivty.vue?vue&type=style&index=0&id=5d5c3fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c3fc8",
  null
  
)

export default component.exports